import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";

export const fmtMoney = (n) =>
  `L ${Number(n || 0).toLocaleString("es-HN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return format(parseISO(String(d).slice(0, 10)), "d MMM yyyy", { locale: es });
  } catch {
    return String(d);
  }
};

export const fmtTime = (d) => {
  if (!d) return "—";
  try {
    return format(parseISO(String(d)), "HH:mm");
  } catch {
    return String(d);
  }
};

export const initials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

export const todayISO = () => format(new Date(), "yyyy-MM-dd");
